import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngxs/store';
import { first, tap } from 'rxjs';
import { LoadProfile } from 'src/app/store-ngxs/actions/profile.actions';
import { ProfileState } from 'src/app/store-ngxs/states/profile.state';

export const profileResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  store: Store = inject(Store)
) => {
  return store.select(ProfileState.loaded).pipe(
    tap((loaded) => {
      if (!loaded) {
        store.dispatch(new LoadProfile());
      }
    }),
    first()
  );
};
